import React from "react";
import emojiStrip from "emoji-strip";
import { InputContainer } from "@networkraildigitalfactory/components";
import styles from "./MyProfile.module.css";
import { preventFormDefault } from "../../services/utils";
import FunctionDropdown from "../DropdownValuesSelect/FunctionDropdown";

const ProfileInputs = (props) => {
  const { inputs, errors, setProfileFormValues, profileFormValues, register, Controller, control } =
    props;
  const onInputChange = (field, value) => {
    setProfileFormValues((prevFormValues) => ({
      ...prevFormValues,
      [field]: emojiStrip(value),
    }));
  };
  return (
    <>
      {inputs.map((input, index) => {
        return (
          <React.Fragment key={input.name}>
            <InputContainer
              labelText={input.labelText}
              exampleText={input.exampleText}
              forLabel={input.forLabel}
              required={input.required}
              errorText={errors[input.name] ? errors[input.name].message : null}
            >
              {input.isThirdPartyComponent ? (
                <Controller
                  as={
                    <FunctionDropdown                      
                      className={`${styles.form_input_dropdown} ${
                        errors.rating ? styles.error : ""
                      }`}
                      value={profileFormValues[input.name]}
                    />
                  }
                  name={input.name}
                  valueName={input.name}
                  onChange={([selected]) => {
                    onInputChange(input.name, selected, false);
                    return selected;
                  }}
                  defaultValue={profileFormValues[input.name]}
                  control={control}
                  rules={{ required: "Must not be blank" }}
                />
              ) : (
                <input
                  name={input.name}
                  autoComplete="new-password"
                  className={`${styles.form_input} ${errors[input.name] ? styles.error : ""}`}
                  type="text"
                  defaultValue={profileFormValues[input.name]}
                  onChange={(e) => onInputChange(input.name, e.target.value)}
                  onKeyDown={preventFormDefault}
                  ref={register({
                    required: {
                      value: input.required,
                      message: input.required ? "Must not be blank" : "",
                    },
                    pattern: {
                      value: input.pattern || /.*/,
                      message: input.patternErrorMessage || "",
                    },
                    minLength: {
                      value: input.minLength || 1,
                      message: `Must be at least ${input.minLength || 1} characters long`,
                    },
                    maxLength: {
                      value: input.maxLength || 150,
                      message: `Must be no more than ${input.maxLength || 150} characters long`,
                    },
                    validate: input.validate && { yourOwnEmail: (value) => input.validate(value) },
                  })}
                  id={input.id || input.forLabel}
                  readOnly={input.readOnly || false}
                  tabIndex={input.readOnly ? -1 : 0}
                />
              )}
            </InputContainer>
            {index === 3 && <hr />}
          </React.Fragment>
        );
      })}
    </>
  );
};

export default ProfileInputs;
